// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3oeSZ","col":"styles_col__m3lp7"};